<ng-template let-row="row" let-value="value">
    <div class="d-flex align-items-center">
        <span>{{value.candidateCount}}</span>
        <span *ngIf="value.candidateNewCount > 0" class="new-text ml-10px">{{value.candidateNewCount}} {{'common.new' | translate | lowercase}}</span>
    </div>
</ng-template>
